import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const headers: Record<string, EnhancedTableHeader> = {
  code: {
    name: 'code',
    title: 'Code',
    type: EnhancedTableHeaderType.Text,
  },
  currency: {
    name: 'currency',
    title: 'Currency',
    type: EnhancedTableHeaderType.Text,
  },
  rate: {
    name: 'rate',
    title: 'Rate',
    type: EnhancedTableHeaderType.Text,
  },
  effectiveFrom: {
    name: 'effectiveFrom',
    title: 'Effective From',
    type: EnhancedTableHeaderType.Date,
  },
  effectiveTo: {
    name: 'effectiveTo',
    title: 'Effective To',
    type: EnhancedTableHeaderType.Date,
  },
};

export function filterSectionsContent(
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        currency: {
          name: 'currency',
          title: 'Currency',
          type: FormInputTypes.newmultiselect,
          value: filterValues?.currency || [],
          placeholder: 'Currency',
          triggerUpdate: true,
          injectGlobalLov: {
            type: 'currency',
            value: 'Id',
            display: 'Title',
          },
        },
        date: {
          name: 'date',
          title: 'Date',
          type: FormInputTypes.newdate,
          value: filterValues.date || null,
          placeholder: 'Date',
          triggerUpdate: true,
          allowDeleteValue: true,
          canClearDate: true,
        },
      },
    },
  ];

  return newFilterSections;
}
